module.exports = Object.assign({},
    require('./utils'),
    require('./statistics'),
    require('./probability'),
    require('./arithmetic'),
    require('./unit'),
    require('./trigonometric')
);
